export default __webpack_public_path__ + "static/media/selenium-logo.996cd388.png";